import React from "react";
import styles from "./index.module.scss";
import { SidebarItemState } from "../../../types/seatApproval";
// import male from "../../../../../assets/images/male.svg";
// import female from "../../../../../assets/images/female.svg";
// import userCircleDashed from "../../../../../assets/images/user-circle-dashed.svg";

interface SideBarItemProps {
  key: string;
  kpiCategory: string;
  icon: string;
  label: string;
  count: number;
  showIcon: boolean;
}

interface SideBarProps {
  selectedSidebarItem: string | SidebarItemState;
  handleSidebarItemClick: (key: string) => void;
  items: SideBarItemProps[];
}

export const SideBar: React.FC<SideBarProps> = ({
  selectedSidebarItem,
  handleSidebarItemClick,
  items,
}) => {
  const padCount = (count: number) => (count < 10 ? `0${count}` : `${count}`);

  console.log("side bar items", items, selectedSidebarItem);

  return (
    <div className={styles.sidebar}>
      {items.map((item) => (
        <div
          key={item.key}
          className={`${styles.sidebarItem} ${
            (selectedSidebarItem?.key || selectedSidebarItem) === item.key
              ? styles.active
              : ""
          }`}
          onClick={() => {
            handleSidebarItemClick(item);
          }}
        >
          {item.showIcon ? (
            <div className={styles.sidebarIcon}>
              <img src={item.icon} alt={item.label} />
            </div>
          ) : (
            <div className={styles.sidebarLabel}>
              {item.label === "Mahatria Choice" ? (
                <span>
                  {/* <span className={styles.mahatriaText}>Mahatria's </span> */}
                  <span className={styles.choiceText}>Any HDB/MSD</span>
                </span>
              ) : (
                <>{item.label}</>
              )}
            </div>
          )}
          <div className={styles.sidebarCount}>{padCount(item.count || 0)}</div>
        </div>
      ))}
    </div>
  );
};
